import { useJobillaOrgId } from '@/hooks'
import { useCampaignInvoiceStatus } from '@jobilla/nexus-sdk'
import { createFileRoute } from '@tanstack/react-router'
import { CampaignInvoice } from '../../../../../ui'

export const Route = createFileRoute(
	'/_auth/company/$companyId/$campaignId/invoice',
)({
	component: RouteComponent,
})

function RouteComponent() {
	const params = Route.useParams()

	const jobillaOrgId = useJobillaOrgId()

	const { data: invoice, isLoading: isLoadingInvoice } = useCampaignInvoiceStatus(
		jobillaOrgId,
		params.campaignId,
	)

	return (
		<CampaignInvoice
			loading={{
				invoice: isLoadingInvoice,
			}}
			view={{
				invoice: invoice?.invoice!,
			}}
			response={{
				invoice: invoice!,
			}}
		/>
	)
}
